import { useEffect } from "react"

import { Segmented, Space } from "antd"
import cls from "classname"
import { useDispatch, useSelector } from "react-redux"

import GlobalActions from "../../Containers/GlobalFilters/reducer"
import { PARTNER_ADMIN_ID } from "../../Utils/utils"
import Button from "../Button"

export const adminOptionsFiltering = [
  { value: "true", label: "Test On" },
  { value: "false", label: "Test Off" }
]

const GlobalFilterTest = ({ usersViewForAdmin, setPageNumber, size, variant }) => {
  const dispatch = useDispatch()
  const { testData } = useSelector((state) => state.globalFilters)
  const { isAdmin, userInfo } = useSelector((state) => state.auth)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const isAdminPage = isAdmin && !usersViewForAdmin
  const isPartnerAdmin = userInfo?.role?.id === PARTNER_ADMIN_ID
  const adminFilterOptions = isPartnerAdmin
    ? adminOptionsFiltering.filter((o) => o.label === "Test On")
    : adminOptionsFiltering

  const handleChangeGlobalFilter = (filterData) => {
    dispatch(GlobalActions.setGlobalFilters(filterData))
    if (typeof setPageNumber === "function") {
      setPageNumber(1)
    }
  }
  useEffect(() => {
    if (!isPartnerAdmin) return

    handleChangeGlobalFilter({ testData: "true" })
  }, [isPartnerAdmin])

  if (!isAdminPage) return null

  if (variant === "compact") {
    return (
      <Space.Compact size={size || "large"}>
        {adminFilterOptions.map((option) => (
          <Button
            key={option.value}
            className={cls("compact-btn", { active: testData === option.value })}
            style={{ width: isMobile && "50%" }}
            onClick={() => handleChangeGlobalFilter({ testData: option.value })}
          >
            {option.label}
          </Button>
        ))}
      </Space.Compact>
    )
  }

  return (
    <Segmented
      options={adminFilterOptions}
      value={testData}
      onChange={(value) => handleChangeGlobalFilter({ testData: value })}
      size={size}
    />
  )
}

export default GlobalFilterTest
